export const GRENKE = 'grenke';
export const SVEA = 'svea';

export const partners = {
  [GRENKE]: 'FRONTDESK / GRENKE',
  [SVEA]: 'SVEA',
};
